export const apiName: string = 'tipos-obrigacoes';
export const obrigacaoTiposRoute: string = 'tipo-obrigacao';
export const obrigacaoTiposStorage: string = 'obrigacaotipos';
export const obrigacaoTiposModuleName: any = {plural: 'Tipos de obrigação', single: 'Tipo de obrigação'};

export const obrigacaoTiposQuery: any =
  {
    "where":{
      "and":[
        {"ativo":true},
        {"titulo":{"regexp":"/REPLACEHERE/i"}},
      ]
    },
    "order":"titulo"
  };



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-tipos/shared/data.service.ts
 **/